import * as types from '../types';

function setSortType(state, action) {
    const {
        meta: filterId,
        payload: sortType,
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            sortType,
        },
    };
}

const sort = {
    [types.SET_SORT_TYPE]: setSortType,
};

export default sort;
